import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/404.css';
import NotFoundIcon from '../assets/img/not-found-icon.svg'; // Ensure you have this SVG file

const NotFound = () => {
    return (
        <div className="not-found">
            <img src={NotFoundIcon} alt="Not Found" />
            <h1>404</h1>
            <p>Leider konnten wir keine gültige Einladung finden.</p>
            <Link to="/">Zurück zur Startseite</Link>
        </div>
    );
};

export default NotFound;